import React, { useState, useCallback } from 'react';
import { useGetUsers } from 'actions/support-agent';
import {
  SearchHeader,
  SearchScroll,
  SearchScrollInner,
  SearchInputWrap,
  SearchTextInput,
  SearchBtn,
  EmptySearch,
  EmptyTitle,
  EmptySub,
  FilterErrorMsg,
} from './styled';
import CustomerResults from './customer-results';
import Icon from '../icon';

const SearchUsersView = ({ activeTicketId, onPickTicket }) => {
  const [userSearchId, setUserSearchId] = useState('');

  const {
    data: customerSearchData,
    get: searchCustomers,
    isProcessing: customerSearchLoading,
    isProcessingFailed: customerSearchFailed,
  } = useGetUsers();

  const customerResults = customerSearchData?.users || [];

  const handleUserSearch = useCallback(() => {
    if (!userSearchId.trim()) return;
    searchCustomers('search-users', { query: userSearchId.trim() });
  }, [userSearchId, searchCustomers]);

  return (
    <>
      <SearchHeader>
        <SearchInputWrap>
          <Icon name="search" size={16} />
          <SearchTextInput
            placeholder="Enter ID, phone, or email..."
            value={userSearchId}
            onChange={e => setUserSearchId(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleUserSearch()}
          />
          <SearchBtn
            onClick={handleUserSearch}
            disabled={!userSearchId.trim() || customerSearchLoading}
          >
            Search
          </SearchBtn>
        </SearchInputWrap>

        {customerSearchFailed && (
          <FilterErrorMsg>Failed to search users. Please try again.</FilterErrorMsg>
        )}
      </SearchHeader>

      <SearchScroll>
        <SearchScrollInner>
          {customerSearchLoading && (
            <EmptySearch>
              <Icon name="loader" size={24} />
              <EmptySub>Searching...</EmptySub>
            </EmptySearch>
          )}

          {!customerSearchLoading && customerSearchData && customerResults.length === 0 && (
            <EmptySearch>
              <Icon name="search" size={32} />
              <EmptyTitle>No customer found</EmptyTitle>
              <EmptySub>Try a different ID, phone, or email</EmptySub>
            </EmptySearch>
          )}

          {!customerSearchLoading && customerResults.length > 0 && (
            <CustomerResults
              customers={customerResults}
              activeTicketId={activeTicketId}
              onTicketClick={onPickTicket}
            />
          )}

          {!customerSearchLoading && !customerSearchData && !customerSearchFailed && (
            <EmptySearch>
              <Icon name="search" size={32} />
              <EmptyTitle>Search for a customer</EmptyTitle>
              <EmptySub align="center">
                Enter an ID, phone number, or email to look up a customer
              </EmptySub>
            </EmptySearch>
          )}
        </SearchScrollInner>
      </SearchScroll>
    </>
  );
};

export default SearchUsersView;
